import type { Message, UserId } from '@cyphex/types';

/**
 * The message Up-arrow should open for editing: the caller's most recent
 * ordinary, still-editable message.
 *
 * Walks backwards and stops at the first candidate rather than filtering the
 * whole list — the timeline can hold tens of thousands of rows and this runs on
 * a keystroke.
 */
export function lastEditableFrom(
  messages: readonly Message[],
  meId: UserId | null,
): Message | null {
  if (meId === null) return null;
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (!message) continue;
    if (message.sender?.id !== meId) continue;
    // Tombstones, system notes, voice clips and scheduled sends have no text to
    // put back in the composer.
    if (message.deletedAt !== null || message.state === 'deleted') continue;
    if (message.kind === 'system' || message.kind === 'voice') continue;
    if (message.state === 'scheduled') continue;
    if (!message.bodyText) continue;
    return message;
  }
  return null;
}
